import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {BotPrompt} from '../../models/bot-prompt';
import {Observable, Subscriber} from 'rxjs';
import {OpenAiRate} from '../../models/open-ai/open-ai-rate';
import {BotStatus} from '../../types/bot-status';

@Injectable({
  providedIn: 'root'
})
export class BotPromptService extends AbstractModelService<BotPrompt> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/bot-prompt', BotPrompt);
  }

  getStatus(parameters: any = {}): Observable<BotStatus> {
    return new Observable<BotStatus>((subscriber: Subscriber<BotStatus>) => {
      this.apiClient.get(this.routePath + '/status', parameters).subscribe((response) => {

        subscriber.next({rates: new OpenAiRate().deserialize(response.getData()['rates']), locked: response.getData()['locked'] ?? false});
        subscriber.complete();
      });
    });
  }
}
